import { c as e } from "react/compiler-runtime";
import { useEffect as t, useRef as n } from "react";
//#region src/hooks/useIsMountedRef.ts
function r() {
	let r = e(2), i = n(!1), a, o;
	return r[0] === Symbol.for("react.memo_cache_sentinel") ? (a = () => (i.current = !0, () => {
		i.current = !1;
	}), o = [], r[0] = a, r[1] = o) : (a = r[0], o = r[1]), t(a, o), i;
}
//#endregion
export { r as useIsMountedRef };
